export { default as UgcComponentRow } from './UgcComponentRow';
